import type { MessageKey } from '@bitwize/i18n-messages';

export interface NavItem {
  /** Path without the locale prefix — `localePath` adds it. */
  path: string;
  labelKey: MessageKey;
}

/**
 * The public navigation.
 *
 * Static in M0. From M3 it is driven by the Website Settings screen, so that
 * hiding a section removes it from the navigation, the sitemap and the search
 * index together rather than leaving a linked page nobody meant to publish.
 *
 * Kept here rather than inlined in the header so that the eventual swap is one
 * module, not a component rewrite.
 */
export const PRIMARY_NAV: readonly NavItem[] = [
  { path: '/projects', labelKey: 'nav.primary.portfolio' },
  { path: '/services', labelKey: 'nav.primary.services' },
  { path: '/technologies', labelKey: 'nav.primary.technologies' },
  { path: '/team', labelKey: 'nav.primary.team' },
  { path: '/faq', labelKey: 'nav.primary.faq' },
  { path: '/contact', labelKey: 'nav.primary.contact' },
];
